module.exports = __webpack_public_path__ + "static/media/bg1.769760c4.jpeg";